module.exports = __webpack_public_path__ + "img/m_brandlogo.28b6a6ca.jpg";